import { jsxs, jsx } from "react/jsx-runtime";
const IconVerifiedBadgeSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.32 11.268a1 1 0 0 0-.8-.321l-.204.013a1 1 0 0 1-1.022-.712l-.06-.202a1 1 0 0 0-.576-.638l-.19-.079a1 1 0 0 1-.606-1.08l.037-.234a1 1 0 0 0-.237-.816l-.151-.172a1 1 0 0 1-.076-1.221l.147-.218A1 1 0 0 0 .72 4.76l-.068-.248a1 1 0 0 1 .456-1.126l.23-.136a1 1 0 0 0 .477-.685l.047-.265a1 1 0 0 1 .9-.82l.247-.021a1 1 0 0 0 .73-.418l.148-.209A1 1 0 0 1 5.063.48l.205.08a1 1 0 0 0 .85-.061l.2-.112a1 1 0 0 1 1.225.196l.137.149a1 1 0 0 0 .8.321l.204-.013a1 1 0 0 1 1.022.712l.06.202a1 1 0 0 0 .576.638l.19.079a1 1 0 0 1 .606 1.08l-.037.234a1 1 0 0 0 .237.816l.151.172a1 1 0 0 1 .076 1.221l-.147.218a1 1 0 0 0-.137.827l.068.248a1 1 0 0 1-.456 1.126l-.23.136a1 1 0 0 0-.477.685l-.047.265a1 1 0 0 1-.9.82l-.247.021a1 1 0 0 0-.73.418l-.149.209a1 1 0 0 1-1.176.353l-.205-.08a1 1 0 0 0-.85.061l-.2.112a1 1 0 0 1-1.225-.196l-.137-.149Zm3.473-7.05a.479.479 0 0 1 .69.663l-3 3.12a.478.478 0 0 1-.69 0l-.004-.005c-.01-.008-.021-.016-.03-.025L3.64 6.808a.513.513 0 0 1 0-.705l.005-.006a.467.467 0 0 1 .68 0l.83.864 2.638-2.743Z"
        }
      )
    ]
  }
);
export {
  IconVerifiedBadgeSvg
};
